"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generarCampoBusqueda = exports.prepararBusqueda = void 0;
const prepararBusqueda = (cadena) => {
    return cadena
        .trim()
        .toLowerCase()
        .replace(/á/g, "a")
        .replace(/é/g, "e")
        .replace(/í/g, "i")
        .replace(/ó/g, "o")
        .replace(/ú/g, "u")
        .replace(/à/g, "a")
        .replace(/è/g, "e")
        .replace(/ì/g, "i")
        .replace(/ò/g, "o")
        .replace(/ù/g, "u")
        .replace(/ñ/g, "n");
};
exports.prepararBusqueda = prepararBusqueda;
const generarCampoBusqueda = (params) => {
    let { buscableExactoPor, buscableParcialPor } = params;
    let stringAux = "";
    const query = new Set();
    if (buscableExactoPor.length > 0) {
        for (const palabraBuscar of buscableExactoPor) {
            if (palabraBuscar == undefined)
                continue;
            const palabra = (0, exports.prepararBusqueda)(palabraBuscar);
            stringAux = palabra.toLowerCase();
            query.add(stringAux);
        }
    }
    // Desgloso las palabras
    if (buscableParcialPor.length > 0) {
        for (const palabraBuscar of buscableParcialPor) {
            if (palabraBuscar == undefined)
                continue;
            const palabra = (0, exports.prepararBusqueda)(palabraBuscar);
            const length = palabra.length;
            for (let i = 0; i <= length; i++) {
                for (let j = i + 1; j <= length; j++) {
                    const palabraTrozo = palabra.slice(i, j);
                    if (palabraBuscar.length <= 60) {
                        if (palabraTrozo.length <= 45) {
                            query.add(palabraTrozo);
                        }
                    }
                    else {
                        if (palabraTrozo.length <= 20) {
                            query.add(palabraTrozo);
                        }
                    }
                }
            }
            const palabraPartes = palabraBuscar.split(" ");
            for (const palabraParte of palabraPartes) {
                const palabra = (0, exports.prepararBusqueda)(palabraParte);
                const length = palabra.length;
                for (let i = 0; i <= length; i++) {
                    for (let j = i + 1; j <= length; j++) {
                        const palabraTrozo = palabra.slice(i, j);
                        if (palabraBuscar.length <= 60) {
                            if (palabraTrozo.length <= 45) {
                                query.add(palabraTrozo);
                            }
                        }
                        else {
                            if (palabraTrozo.length <= 20) {
                                query.add(palabraTrozo);
                            }
                        }
                    }
                }
            }
        }
    }
    if (buscableParcialPor.length > 0) {
        for (const palabraBuscar of buscableParcialPor) {
            if (palabraBuscar == undefined)
                continue;
            const palabra = (0, exports.prepararBusqueda)(palabraBuscar);
            stringAux = palabra.toLowerCase();
            query.add(stringAux);
        }
    }
    const salida = Array.from(query).filter(x => x != "" && x != " ");
    return salida;
};
exports.generarCampoBusqueda = generarCampoBusqueda;
